import { Phone, Store, Upload, Zap } from "lucide-react";
import Button from "../../components/ui/button";
import { LeadFormDialog } from "./LeadFormDialog";
import { useTranslation } from "react-i18next";

const steps = [
  {
    icon: Phone,
    number: "1",
    title: "Sign up with your phone number",
    description: "Quick registration, no complicated forms",
  },
  {
    icon: Store,
    number: "2",
    title: "Choose your shop type",
    description: "Grocery, pharmacy, clothing, or more",
  },
  {
    icon: Upload,
    number: "3",
    title: "Upload products via Excel",
    description: "Bulk import made easy",
  },
  {
    icon: Zap,
    number: "4",
    title: "Start selling instantly",
    description: "You're ready to go!",
  },
];

export const HowItWorksSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-8 md:py-12 bg-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          {t("How It Works")}
        </h2>
        <p className="text-center text-muted-foreground mb-8 md:mb-12 text-base md:text-lg">
          {t("Get started in 4 simple steps")}
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-8 md:mb-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative rounded-2xl p-[1px] bg-gradient-to-r from-[#1b4597] via-[#3FBEE9] to-[#7EC242] 
                 shadow-[var(--shadow-soft)] hover:shadow-[var(--shadow-medium)] transition-all duration-300"
            >
              {/* Inner card */}
              <div className="bg-card p-4 md:p-6 rounded-2xl text-center h-full">
                <div
                  className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-6 h-6 md:w-8 md:h-8 rounded-full 
                        bg-primary text-primary-foreground font-bold flex items-center justify-center text-[10px] md:text-sm"
                >
                  {step.number}
                </div>

                <div className="flex justify-center mb-3 md:mb-4">
                  <div className="bg-blue-100 p-3 md:p-4 rounded-full flex items-center justify-center">
                    <step.icon className="w-5 h-5 md:w-8 md:h-8 text-primary" />
                  </div>
                </div>

                <h3 className="text-sm md:text-lg font-semibold text-foreground mb-1 md:mb-2">
                  {t(step.title)}
                </h3>
                <p className="text-[11px] md:text-sm text-muted-foreground leading-snug md:leading-normal">
                  {t(step.description)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-base sm:text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
            {t("Simple, fast, and powerful. Fill the form now to get started.")}
          </p>
          <LeadFormDialog>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 md:px-8 py-4 md:py-6 text-base md:text-lg">
              {t("Get Started Now")}
            </Button>
          </LeadFormDialog>
        </div>
      </div>
    </section>
  );
};
